import { styled } from '@mui/material/styles';

import Container from 'common/components/material/Container';
import colorPalette from 'common/theme/colorPalette';

type VerticalScrollableContainerProps = {
  maxHeight?: string;
  minHeight?: string;
};

const VerticalScrollableContainer = styled(Container, {
  shouldForwardProp: (prop) => {
    return prop !== 'maxHeight' && prop !== 'minHeight';
  },
})<VerticalScrollableContainerProps>(({ maxHeight, minHeight }) => {
  return {
    maxHeight,
    minHeight,
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: '4px',
      height: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent',
      borderRadius: '4px',
    },

    /* Handle on hover */
    '::-webkit-scrollbar-thumb:hover': {
      background: colorPalette.GRAY500,
    },
  };
});

export default VerticalScrollableContainer;
